import { Button } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { gameModel } from 'entities/game';
import { Lighting, NumberFormatter } from 'shared/ui';
import { betMenuModel } from '../../model';
import cls from './bet-menu-bet-button.module.scss';

export const BetMenuBetButton = () => {
	const { t } = useTranslation();

	const [betting, betDisabled, profit, cashoutDisabled, currency, cashout, enableOnboarding] =
		useUnit([
			betMenuModel.$betting,
			betMenuModel.$betButtonDisabled,
			betMenuModel.$profit,
			betMenuModel.$cashoutButtonDisabled,
			gameModel.$currency,
			betMenuModel.cashoutButtonClicked,
			betMenuModel.$enableOnboardingBetButton,
		]);

	return (
		<Lighting
			enabled={enableOnboarding}
			className={cls.betMenuBetButtonLighting}
		>
			<Button
				fullWidth
				type={betting ? 'submit' : 'button'}
				disabled={betting ? betDisabled : cashoutDisabled}
				data-onboarding={enableOnboarding || undefined}
				classNames={{
					root: cls.betMenuBetButton,
					label: cls.betMenuBetButtonLabel,
				}}
				onClick={betting ? undefined : cashout}
			>
				{betting ? (
					t('bet-menu.play')
				) : (
					<>
						{t('bet-menu.get')}
						{profit > 0 && (
							<>
								<NumberFormatter
									fixedDecimalScale
									value={profit}
									thousandSeparator=' '
									decimalScale={2}
									className={cls.betMenuCashoutButtonProfit}
								/>
								{currency}
							</>
						)}
					</>
				)}
			</Button>
		</Lighting>
	);
};
